




















import { Component, Vue } from "vue-property-decorator";
import RouteInfoDashbordHeader from "@/components/route-info/dashbord/route-info-dashbord-header.vue";
import RouteInfoV2 from "@/components/route-info/v2/route-info-v2.vue";

@Component({ components: { RouteInfoDashbordHeader, RouteInfoV2 } })
class RouteInfoV2Page extends Vue {
  listVariant = "route";
  showTrash = false;
  $refs!: { RouteInfoV2: InstanceType<typeof RouteInfoV2> };

  public addCity(): void {
    this.$refs.RouteInfoV2.openCityAddModal();
  }
  public addRoute(): void {
    this.$refs.RouteInfoV2.openRouteAddModal();
  }
  public toggleTrash(): void {
    this.showTrash = !this.showTrash;
    this.$refs.RouteInfoV2.toggleTrash();
  }
}
export default RouteInfoV2Page;
